var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthenticateFrame',[_c('ar-text',{style:({
      marginBottom: '40px',
    }),attrs:{"text":"Verifying your email","size":"lg","multiple-lines":""}}),_vm._v(" "),(_vm.isVerifyingEmailAddress)?_c('am2-loading-bubble',{style:({
      color: _vm.$arStyle.color.purple500,
      marginLeft: '20px'
    })}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }